module.exports = __webpack_public_path__ + "static/img02-72eda01b49116c9b220af03f906a9722.png";